import { useIntl } from 'react-intl';
import { useDispatch } from '_common/hooks';
import { Icon, Tooltip } from '@ets/design-system';
import { openModal } from '_common/modals/ModalsSlice';
import styles from './SupportButton.module.scss';

/**
 * SupportButton
 *
 * Replaces the native Zendesk widget trigger button
 */
const SupportButton = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  return (
    <Tooltip
      content={intl.formatMessage({ id: 'global.support' })}
      placement="left"
      testId="login-help"
    >
      <div
        className={styles.root}
        onClick={() => {
          dispatch(openModal('SupportFormModal'));
        }}
        data-testid="login-help-button"
      >
        <Icon
          icon="circle-question"
          iconPrefix="far"
          color="neutral"
          size="4"
          testId="login-help"
        />
      </div>
    </Tooltip>
  );
};

export default SupportButton;
